import { useState } from "react";

/** Open state of the two dialogs a transaction row opens (Manually Match, Mark as). */
export interface TransactionDialogsState {
  matchOpen: boolean;
  setMatchOpen: (open: boolean) => void;
  markAsOpen: boolean;
  setMarkAsOpen: (open: boolean) => void;
}

export function useTransactionDialogs(): TransactionDialogsState {
  const [matchOpen, setMatchOpen] = useState(false);
  const [markAsOpen, setMarkAsOpen] = useState(false);
  return { matchOpen, setMatchOpen, markAsOpen, setMarkAsOpen };
}
